<template>
  <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.917 14v-1.667h-5c-.69 0-1.25-.56-1.25-1.25V1.917c0-.69.56-1.25 1.25-1.25h14.166c.69 0 1.25.56 1.25 1.25v9.166c0 .69-.56 1.25-1.25 1.25h-5V14h.417c1.15 0 2.083.933 2.083 2.083v.834c0 .23-.186.416-.416.416H4.833a.417.417 0 0 1-.416-.416v-.834c0-1.15.932-2.083 2.083-2.083h.417zm0 .833H6.5c-.69 0-1.25.56-1.25 1.25v.417h7.5v-.417c0-.69-.56-1.25-1.25-1.25H6.917zM7.75 14h2.5v-1.667h-2.5V14zm3.333-2.5h5c.23 0 .417-.187.417-.417V1.917a.417.417 0 0 0-.417-.417H1.917a.417.417 0 0 0-.417.417v9.166c0 .23.187.417.417.417h9.166zM8.695 9.595c-.562-.52-1.763-.682-3.602-.425a.417.417 0 0 1-.475-.413V3.944c0-.166.1-.316.252-.382 1.555-.673 2.956-.486 4.13.552 1.174-1.038 2.575-1.225 4.13-.552a.417.417 0 0 1 .252.382v4.813a.417.417 0 0 1-.475.413c-1.839-.257-3.04-.094-3.602.425A.419.419 0 0 1 9 9.728a.405.405 0 0 1-.305-.133zm.722-1.046c.748-.327 1.791-.408 3.131-.263v-4.06c-1.21-.445-2.231-.235-3.131.637V8.55zm-.834-3.686c-.9-.872-1.921-1.082-3.131-.637v4.06c1.34-.145 2.383-.064 3.131.263V4.863z"
      :fill="color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
	name: "OnlineCourse",
	props: {
		isDarker: {
			type: Boolean,
			default() {
				return false;
			},
		},
		color: {
			type: String,
			default() {
				return this.isDarker ? '#383838' : '#ABABAB';
			},
		},
	},
};
</script>

<style scoped></style>
